import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MasterDataService } from '../../services/master-data.service';
import * as html2pdf from 'html2pdf.js';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-article-debit-credit-hours',
  templateUrl: './article-debit-credit-hours.component.html',
  styleUrls: ['./article-debit-credit-hours.component.css']
})
export class ArticleDebitCreditHoursComponent implements OnInit {
  financialYearList;
  articleNameList;
  branchList;
  selectedFinancialYear;
  selectedBranch;
  selectArticle;
  role;
  isBranchSelected = false;
  debitCreditReportList;
  userId;
  userType;
  userRole;
  accessResponse: any;
  selectedPartner;
  partnerList;
  selectedUser;
  isFromMyReportList = false;


  constructor(private masterDataService: MasterDataService, private commonMessageService: CommonMessageService, private branchFilterService: BranchFilterService) { }

  ngOnInit(): void {
    this.isFromMyReportList = history.state.isFromMyReportList || false;
    console.log('isFromMyReportList:', this.isFromMyReportList);
    this.selectedFinancialYear = "";
    this.selectArticle = "";
    this.loadInitDetails();
    this.userId = localStorage.getItem('id');
    this.userType = localStorage.getItem('userType');
  }

  loadInitDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialYearList = res;
    });
  }

  onYearselected() {
    this.selectedBranch = [];
    this.selectArticle = [];
    this.role = "";
    this.diaryDebitCreditReportList = null;
    this.leaveDebitCreditReportList = null;
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  onBranchSelected() {
    this.role = 'Article';
    // this.loadArticleList();
    this.selectedPartner = '';
    if (this.selectedBranch.length != 0 && this.selectedBranch != undefined) {
      this.onPartnerSelected();
    }
  }

  onPartnerSelected() {
    const branchId = this.selectedBranch.map(({ id }) => id);
    this.masterDataService
      .getUserPartnersOfBranch(branchId)
      .subscribe((res) => {
        console.log('select partner', res);
        this.partnerList = res;
      });
  }

  onUserSelected() {
    this.selectedUser = '';
    if (
      this.selectedPartner != '' &&
      this.selectedPartner != undefined &&
      this.selectedPartner != null
    ) {
      this.masterDataService
        .getUsersOfPartner(this.selectedPartner.id)
        .subscribe((res: any[]) => {
          if (!this.isFromMyReportList) {
            this.articleNameList = res;
          } else {
            const userIdInt = parseInt(this.userId, 10);
            const filteredList = res.filter(article => article.id === userIdInt);
            if (filteredList.length > 0) {
              this.articleNameList = filteredList;
            } else {
              this.articleNameList = []; // or handle as necessary
              console.log('No articles found for the given userId');
            }
          }
        });
    }
  }

  loadArticleList() {
    var branchId = this.selectedBranch.map(({ id }) => id);
    console.log('branchID', branchId);
    this.masterDataService.getArticleListByBranch(branchId).subscribe({
      next: (resp: any) => {
        console.log('article list by branch', resp);
        const userIdInt = parseInt(this.userId, 10);
        // Filter the article list to keep only the object with the matching userId

        if (this.userType === 'Article') {
          const filteredList = resp.filter(article => article.id === userIdInt);
          if (filteredList.length > 0) {
            this.articleNameList = filteredList;
          } else {
            this.articleNameList = []; // or handle as necessary
            console.log('No articles found for the given userId');
          }
        }
        else {
          this.articleNameList = resp;
        }
      },
      error: (err) => {
        console.error('Error loading article list', err);
        // Handle error as necessary, e.g., display an error message to the user
      },
      complete: () => {
        console.log('Article list loading complete');
      }
    });


  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected);
    this.isBranchSelected = !this.isBranchSelected;
    this.onBranchSelected();
  }

  selectAllArticleName(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected);
    this.isBranchSelected = !this.isBranchSelected;
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  diaryDebitCreditReportList;
  leaveDebitCreditReportList;
  articleId;
  showExportToExcelButton: boolean;
  // onViewReport() {
  //   console.log('this.diaryDebitCreditReportList', this.diaryDebitCreditReportList, 'this.leaveDebitCreditReportList', this.leaveDebitCreditReportList);
  //   this.articleId = this.selectArticle.map(({ id }) => id);
  //   console.log('article name list', this.articleId);
  //   this.masterDataService.getDebitCreditHoursDetails(this.selectedFinancialYear.id, this.articleId).subscribe((resp: any) => {
  //     console.log('debit credit hours  details', resp);
  //     this.leaveDebitCreditReportList = resp.leveDetails;
  //     this.diaryDebitCreditReportList = resp.diaryDetails;
  //     this.showExportToExcelButton = true;
  //     // if (this.diaryDebitCreditReportList == null) {
  //     //    this.commonMessageService.swalAlertWithoutIcon('','No Record Found.');
  //     // } else {
  //     //   this.diaryDebitCreditReportList = resp.diaryDetails;
  //     // }
  //     // if (this.debitCreditReportList.leveDetails == null) {
  //     //    this.commonMessageService.swalAlertWithoutIcon('','No Record Found.');
  //     // } else {
  //     //   this.leaveDebitCreditReportList = resp.leveDetails;
  //     // }
  //   });
  // }

  onViewReport() {

    console.log(
      'this.diaryDebitCreditReportList',
      this.diaryDebitCreditReportList,
      'this.leaveDebitCreditReportList',
      this.leaveDebitCreditReportList
    );
    this.articleId = this.selectArticle.map(({ id }) => id);

    console.log('article name list', this.articleId);

    this.masterDataService.getDebitCreditHoursDetails(this.selectedFinancialYear.id, this.articleId)
      .subscribe((resp: any[]) => {
        console.log('debit credit hours details', resp);

        this.diaryDebitCreditReportList = resp.reduce(
          (result: any[], item: any) => {
            if (item.diaryDetails && item.diaryDetails.length > 0) {
              result = result.concat(item.diaryDetails);
            }
            return result;
          },
          []
        );

        this.leaveDebitCreditReportList = resp.reduce(
          (result: any[], item: any) => {
            if (item.leveDetails && item.leveDetails.length > 0) {
              result = result.concat(item.leveDetails);
            }
            return result;
          },
          []
        );

        this.diaryDebitCreditReportList =
          this.diaryDebitCreditReportList.map((diary: any) => {
            const leaveDetail = this.leaveDebitCreditReportList.find((leave: any) => leave.id === diary.id);
            return {
              ...diary,
              leaveDetail: leaveDetail
            };

          });
        console.log('Final Diary Debit Credit Report List:', this.diaryDebitCreditReportList);
        console.log('Final Leave Debit Credit Report List:', this.leaveDebitCreditReportList);
        this.showExportToExcelButton = true;

      });
  }

  exportToExcelClick() {
    this.masterDataService.getDebitCreditHoursExportToExcel(this.selectedFinancialYear.id, this.articleId).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "ArticleDebitCreditHoursReport.xlsx";
      link.click();
    });
  }

  exportToPDFClick() {
    var element = document.getElementById('elementsForPDF');
    var opt = {
      //  margin:  1,
      filename: 'ArticleDebitCreditHoursReport.pdf',
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { unit: 'mm', format: 'letter', orientation: 'landscape' }
    };

    // html2pdf().set({
    //   pagebreak: { mode: 'avoid-all', before: '#forPageBreak' }
    // });

    html2pdf().from(element).set(opt).save();

  }
}
